<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("ROOM_TYPE") }}</h4>
      <v-btn color="primary" @click="addNew">
        <v-icon dark>
          mdi-plus
        </v-icon>
        {{ $t("ADD_NEW_ROOM") }}
      </v-btn>
    </div>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pl-3 pr-3">
        <v-col sm="4">
          <v-text-field v-model="keyword" :label="$t('_ROOM_SALE.ENTER_HOTEL_NAME_OR_CODE')" v-on:change="getAll(1)"
            class="mt-0 pt-0"></v-text-field>
        </v-col>
        <v-col sm="8">
          <v-radio-group v-model="status" row class="mt-0" @change="getAll(1)">
            <v-radio :label="$t('ALL')" value="all"></v-radio>
            <v-radio :label="$t('ACTIVE')" value="1"></v-radio>
            <v-radio :label="$t('DEACTIVE')" value="0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <loading :active.sync="isLoadingPopup" :is-full-page="false"></loading>
      <v-simple-table fixed-header height="calc(100vh - 269px)">
        <template v-slot:default>
          <thead>
            <tr>
              <th v-for="header in headers" :class="header.class">
                <div v-if="header.value == 'status'" @click="sortStatus(asc, 1)" style="cursor: pointer">{{ header.text }}
                </div>
                <div v-else-if="header.value == 'defaultPrice' || header.value == 'weekendRate'">
                  {{ header.text }} <small>( {{ currency }} )</small>
                </div>
                <div v-else>
                  {{ header.text }}
                </div>
              </th>
            </tr>
          </thead>
          <draggable v-if="!isLoading" v-model="dataTable" tag="tbody" animation="150" handle=".sort"
            @end="changeOrderList">
            <!-- <tbody> -->
            <template v-if="dataTable.length > 0 && !isLoading">
              <tr v-for="(item, i) in dataTable">
                <td class="text-center vertical-middle">{{ i + 1 }}</td>
                <td class="vertical-middle">
                  {{ item.roomCode }}
                </td>
                <td class="font-weight-bold vertical-middle">
                  <a class="app-link text-decoration-none" href="javascript:;" @click="editItem(item)">
                    {{
                      item.i18ns.find(x => x.lang == defaultI18n).name
                    }}
                    <span class="txt-child ml-3" v-if="item.parentId">D</span>
                  </a>
                </td>
                <td class="text-right vertical-middle">
                  {{ _formatCurrency(item.defaultPrice) }}
                </td>
                <td class="text-right vertical-middle">
                  {{ _formatCurrency(item.weekendRate) }}
                </td>
                <td class="vertical-middle txt-nowrap">
                  {{ item.maxAdults }} {{ $t("ADULT") }},
                  {{ item.maxChildren }} {{ $t("CHILDREN") }}
                </td>
                <td class="text-right vertical-middle">
                  {{ item.totalRooms }}
                </td>
                <td class="text-center vertical-middle">
                  <div class="d-flex justify-center">
                    <v-switch v-model="item.status" class="item-switch m-0 p-0 align-center"
                      @change="changeStatus(item)"></v-switch>
                  </div>
                </td>
                <td class="text-center vertical-middle txt-nowrap">
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed @click="editItem(item)" x-small class="rounded-sm mr-1" v-bind="attrs" v-on="on"
                        color="primary" outlined>
                        <v-icon size="15">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("EDIT") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed color="error" @click="$refs.deleteDialogComponent.open(item)" x-small
                        v-bind="attrs" v-on="on" class="rounded-sm mr-1" outlined>
                        <v-icon size="15">
                          delete
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("DELETE") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed x-small v-bind="attrs" v-on="on" class="rounded-sm sort" outlined
                        style="cursor: move">
                        <v-icon size="15">
                          mdi-arrow-all
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("SORT") }}
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8" class="text-center vertical-middle font-weight-bold font-italic" style="color:red">
                  {{ $t('NO_DATA') }}
                </td>
              </tr>
            </template>
            <!-- </tbody> -->
          </draggable>
        </template>
      </v-simple-table>
      <b-row>
        <b-col md="4" class="d-flex align-center">
          <span class="txt-child ml-3 mr-3">D</span> <span class="fs-12">{{ $t("ROOM_DERIVE") }}</span>
        </b-col>

        <b-col md="4" class="text-center">
          <a v-if="dataTable.length < paging.total" class="text-primary" @click="showMore()">{{
            $t('SHOW_MORE')
          }}
            <i class="icon-keyboard_double_arrow_down"> </i>
          </a>
        </b-col>
        <b-col md="4" class="text-right">
          <span v-if="paging" class="pr-3">{{ $tc('TO_PAGE', dataTable.length) }} | {{ $t("TOTAL") }}: {{ paging.total }}
            {{ $t("ROOM") }}</span>
        </b-col>
      </b-row>

      <delete-dialog @deleteItem="deleteItem" ref="deleteDialogComponent">
        <span slot="title">{{ $t("CONFIRM_DELETE_ROOM") }}?</span>
      </delete-dialog>
      <confirm-dialog @deleteItem="changeStatusItem" @cancelDelete="cancelDelete" :maxWidth="480" :persistent="true"
        ref="changeStatusDialogComponent">
        <span slot="title">{{ $t("CONFIRM_CHANGE_STATUS_ROOMTYPE") }}</span>
      </confirm-dialog>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import draggable from "vuedraggable";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
export default {
  components: {
    "delete-dialog": DeleteDialog,
    "confirm-dialog": ConfirmDialog,
    paging: Paging,
    draggable
  },
  data() {
    return {
      currency: null,
      isLoading: true,
      isLoadingPopup: false,
      systemLang: this.$i18n.locale,
      isListingPage: true,
      dialog: false,
      sortDesc: true,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("HOTEL_LOG_roomId"),
          value: "roomCode",
        },
        {
          text: this.$t("ROOM_NAME"),
          value: "name",
        },
        {
          text: this.$t("PRICE_NORMAL_DAY"),
          value: "defaultPrice",
          class: "text-right"
        },
        {
          text: this.$t("PRICE_WEEKEND"),
          value: "weekendRate",
          class: "text-right"
        },
        {
          text: this.$t("MAX_CUSTOMER_COUNT"),
          value: "maxCustomers",
          class: "text-left"
        },
        {
          text: this.$t("TOTAL_ROOM"),
          value: "totalRooms",
          width: "13%",
          class: "text-right"
        },
        {
          text: this.$t("STATUS"),
          class: "text-center",
          value: "status",
        },
        {
          text: this.$t("ACTION"),
          class: "text-center"
        }
      ],
      data: [],
      dataTable: [],
      selected: [],
      editedIndex: -1,
      editedItem: null,
      keyword: "",
      status: "all",
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      orderBy: "active",
      asc: false
    };
  },
  created() {
    this.currency = this.usedCurrency;
    this.initialize();
  },
  watch: {},
  methods: {
    initialize() {
      // if (this.$session.exists() && this.$session.getAll().ojbListRoom) {
      //   this.paging.limit = this.$session.get("ojbListRoom").limit;
      //   this.paging.offset = this.$session.get("ojbListRoom").offset;
      // }
      this.getAll(true);
    },
    changeOrderList() {
      let tmp = [];
      setTimeout(() => {
        tmp = this.dataTable.map(e => { return e.roomId });
        service.sortIndexRoom(tmp).then(res => {
          if (res.responseCode !== 0) {
            this.initialize();
          }
          _alert(res, this.$t(res.data), false);
        });
      }, 500);
    },
    async getAll(isSearching) {
      this.$session.set("ojbListRoom", this.paging);
      if (isSearching) {
        this.paging.offset = 0;
        this.data = [];
        this.dataTable = [];
      }
      let body = {};
      body.keyword = this.keyword;
      if (this.status === "all") {
        body.status = null;
      } else {
        body.status = this.status;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      body.orderBy = this.orderBy;
      body.asc = this.asc;
      this.isLoading = true;
      await service.getAllRooms(body).then(res => {
        this.data = this.data.concat(res.data);
        this.dataTable = this.dataTable.concat(res.data);
        this.paging.total = res.total;
      }).finally(() => (this.isLoading = false));
    },
    showMore() {
      if (this.paging.total - this.dataTable.length > 0) {
        this.paging.offset += this.paging.limit;
        this.getAll();
      }

    },
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    sortStatus(asc, isSearching) {
      if (asc) {
        this.asc = false;
      } else {
        this.asc = true;
      }
      this.getAll(isSearching);
    },
    addNew() {
      this.$router.push({
        name: "roomDetail",
        params: { id: "00000000-0000-0000-0000-000000000000" }
      });
    },
    editItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        name: "roomDetail",
        params: { id: item.roomId }
      });
      localStorage.removeItem("RoomDetail");
    },
    cancelDelete(item) {
      item.status = !item.status;
    },
    deleteItem(item) {
      const index = this.data.indexOf(item);
      service.removeRoom(item.roomId).then(res => {
        if (res.responseCode == 0) {
          this.initialize();
        }
        _alert(res, this.$t(res.data), false);
      });
    },
    changeStatusItem(item) {
      this.isLoadingPopup = true;
      this.changeStatus(item);
    },
    changeStatus(item) {
      let body = {
        id: item.roomId,
        status: item.status ? 1 : 0
      };
      service.updateRoomStatus(body).then(res => {
        if (res.responseCode === 1) item.status = !item.status;
        _alert(res, this.$t(res.data), true);
      });
    },
    _formatCurrency: _formatCurrency
  }
};
</script>
